import { Box3, Line3, Mesh, Plane, Sphere, Triangle, Vector3 } from 'three';
import Capsule from './CapsuleControls';
import base62 from '../../utils/ascii';
const _v1 = new Vector3();
const _v2 = new Vector3();
const _v3 = new Vector3();
const _plane = new Plane();
const _line1 = new Line3();
const _line2 = new Line3();
const _sphere = new Sphere();
const _capsule = new Capsule();
let boxNum = 0;
let realTotalNum = 0;
let totalNum = 0;
class Octree {
    triangles;
    triangleIndexs;
    box;
    list;
    bounds;
    subTrees;
    constructor(box, triangles = [], subTrees = []) {
        this.box = new Box3(new Vector3(box?.min.x, box?.min.y, box?.min.z), new Vector3(box?.max.x, box?.max.y, box?.max.z));
        this.triangles = triangles?.map((triangle) => {
            return new Triangle(new Vector3(triangle.a.x, triangle.a.y, triangle.a.z), new Vector3(triangle.b.x, triangle.b.y, triangle.b.z), new Vector3(triangle.c.x, triangle.c.y, triangle.c.z));
        });
        // this.subTrees = subTrees?.map((tree) => {
        //   const subTree = new Octree(tree.box, tree.triangles, tree.subTrees);
        //   return subTree;
        // });
        // this.triangles = triangles;
        // this.box = box;
        this.triangleIndexs = [];
        this.bounds = new Box3(); // 外接盒子
        this.subTrees = subTrees;
    }
    /**
     * 添加三角形，并且更新边界值，保证bounds能覆盖目前为止所有三角形
     * @param { Triangle } triangle 三角形
     * @returns { Octree } 返回Octree本身
     */
    addTriangle(triangle) {
        this.bounds.min.x = Math.min(this.bounds.min.x, triangle.a.x, triangle.b.x, triangle.c.x);
        this.bounds.min.y = Math.min(this.bounds.min.y, triangle.a.y, triangle.b.y, triangle.c.y);
        this.bounds.min.z = Math.min(this.bounds.min.z, triangle.a.z, triangle.b.z, triangle.c.z);
        this.bounds.max.x = Math.max(this.bounds.max.x, triangle.a.x, triangle.b.x, triangle.c.x);
        this.bounds.max.y = Math.max(this.bounds.max.y, triangle.a.y, triangle.b.y, triangle.c.y);
        this.bounds.max.z = Math.max(this.bounds.max.z, triangle.a.z, triangle.b.z, triangle.c.z);
        this.triangles.push(triangle);
        return this;
    }
    /**
     * 添加三角形索引，并且更新边界值，保证bounds能覆盖目前为止所有三角形
     * @param { String } index 索引
     * @returns { Octree } 返回Octree本身
     */
    addTriangleIndex(index) {
        if (!this.bounds)
            this.bounds = new Box3();
        const triangle = this.list?.[base62.decode(index)];
        if (triangle) {
            this.bounds.min.x = Math.min(this.bounds.min.x, triangle.a.x, triangle.b.x, triangle.c.x);
            this.bounds.min.y = Math.min(this.bounds.min.y, triangle.a.y, triangle.b.y, triangle.c.y);
            this.bounds.min.z = Math.min(this.bounds.min.z, triangle.a.z, triangle.b.z, triangle.c.z);
            this.bounds.max.x = Math.max(this.bounds.max.x, triangle.a.x, triangle.b.x, triangle.c.x);
            this.bounds.max.y = Math.max(this.bounds.max.y, triangle.a.y, triangle.b.y, triangle.c.y);
            this.bounds.max.z = Math.max(this.bounds.max.z, triangle.a.z, triangle.b.z, triangle.c.z);
        }
        this.triangleIndexs.push(index);
        return this;
    }
    /**
     * 计算盒子大小
     * @returns { Octree } 返回Octree本身
     */
    calcBox() {
        this.box = this.bounds.clone();
        this.box.min.x -= 0.01;
        this.box.min.y -= 0.01;
        this.box.min.z -= 0.01;
        return this;
    }
    /**
     * 八叉树构建
     * @param { number } level 层级
     * @returns { Octree } 返回Octree本身
     */
    split(level) {
        if (!this.box)
            return;
        const subTrees = [];
        const halfSize = _v2.copy(this.box.max).sub(this.box.min).multiplyScalar(0.5); // 盒子的中点
        // 八个子树
        for (let x = 0; x < 2; x++) {
            for (let y = 0; y < 2; y++) {
                for (let z = 0; z < 2; z++) {
                    const box = new Box3();
                    const v = _v1.set(x, y, z);
                    box.min.copy(this.box.min).add(v.multiply(halfSize)); // 八个小盒子min
                    box.max.copy(box.min).add(halfSize); // 八个小盒子对应的max（对角线）
                    subTrees.push(new Octree(box));
                }
            }
        }
        // 将三角面放到这些子树中
        let triangle;
        while ((triangle = this.triangles.pop())) {
            for (let i = 0, len = subTrees.length; i < len; i++) {
                if (subTrees[i].box?.intersectsTriangle(triangle)) {
                    // 检测盒子是否与三角形相交
                    subTrees[i].triangles.push(triangle);
                }
            }
        }
        // 判断子树中三角面数量，决定是否向下继续划分子树
        for (let i = 0, len = subTrees.length; i < len; i++) {
            const childrenLen = subTrees[i].triangles.length;
            if (childrenLen > 100 && level < 16) {
                // 阈值，每个盒子里最多100个，且深度最多16层
                subTrees[i].split(level + 1);
            }
            if (childrenLen !== 0) {
                boxNum++;
                this.subTrees.push(subTrees[i]);
            }
        }
        return this;
    }
    /**
     * 根据现有三角面组构建八叉树
     * @returns { Octree } 返回Octree本身
     */
    build() {
        this.calcBox();
        this.split(0);
        console.log('总立方体数', boxNum);
        return this;
    }
    /**
     * 获取射线穿过盒子中的所有三角面
     * @param { Ray } ray  射线
     * @param { Array } triangles 三角面组
     */
    getRayTriangles(ray, triangles) {
        for (let i = 0, len = this.subTrees.length; i < len; i++) {
            const subTree = this.subTrees[i];
            if (!subTree.box)
                continue;
            if (!ray.intersectsBox(subTree.box))
                continue; // 判断射线与盒子是否相交
            if (subTree.triangles.length > 0) {
                for (let j = 0, len = subTree.triangles.length; j < len; j++) {
                    const triangle = subTree.triangles[j];
                    if (triangles.indexOf(triangle) === -1)
                        triangles.push(triangle);
                }
            }
            else {
                subTree.getRayTriangles(ray, triangles);
            }
        }
    }
    /**
     * 获取线段穿过盒子中的所有三角面
     * @param { Line3 } line  线段
     * @param { Boolean } triangles 三角面组
     */
    getLineTriangles(line, triangleIndexs, list) {
        if (!list)
            return;
        for (let i = 0, len = this.subTrees.length; i < len; i++) {
            const subTree = this.subTrees[i];
            if (!subTree.box)
                continue;
            const center = new Vector3();
            const target = new Vector3();
            subTree.box.getCenter(center);
            line.closestPointToPoint(center, true, target);
            if (!subTree.box.containsPoint(target))
                continue; // 判断线段与盒子是否相交
            if (subTree.triangleIndexs.length > 0) {
                for (let j = 0, len = subTree.triangleIndexs.length; j < len; j++) {
                    triangleIndexs.add(subTree.triangleIndexs[j]);
                }
            }
            else {
                subTree.getLineTriangles(line, triangleIndexs, list);
            }
        }
    }
    /**
     * 收集所有与球体相交盒子里的三角面
     * @param { Sphere } sphere 球体
     * @param { Triangle[] } triangleIndexs 三角形列表
     */
    getSphereTriangles(sphere, triangleIndexs, list) {
        if (!list)
            return;
        for (let i = 0, len = this.subTrees.length; i < len; i++) {
            const subTree = this.subTrees[i];
            if (!subTree.box)
                continue;
            if (!sphere.intersectsBox(subTree.box))
                continue; // 检测球体是否与盒子相交
            if (subTree.triangleIndexs.length > 0) {
                for (let j = 0, num = subTree.triangleIndexs.length; j < num; j++) {
                    triangleIndexs.add(subTree.triangleIndexs[j]);
                }
            }
            else {
                subTree.getSphereTriangles(sphere, triangleIndexs, list);
            }
        }
    }
    /**
     * 收集所有与胶囊体相交盒子里的三角面
     * @param { Sphere } sphere 球体
     * @param { Triangle[] } triangles 三角形列表
     */
    getCapsuleTriangles(capsule, triangleIndexs, list) {
        if (!list)
            return;
        for (let i = 0; i < this.subTrees.length; i++) {
            const subTree = this.subTrees[i];
            if (!subTree.box)
                continue;
            if (!capsule.intersectsBox(subTree.box))
                continue;
            if (subTree?.triangleIndexs.length > 0) {
                for (let j = 0, len = subTree.triangleIndexs.length; j < len; j++) {
                    triangleIndexs.add(subTree.triangleIndexs[j]);
                }
            }
            else {
                subTree.getCapsuleTriangles(capsule, triangleIndexs, list);
            }
        }
    }
    /**
     * 获取射线穿过盒子中的所有三角面
     * @param { Ray } ray  射线
     * @param { Array } triangleIndexs 三角面索引组
     */
    getRayTriangleIndexs(ray, triangleIndexs, list) {
        if (!list)
            return;
        for (let i = 0, len = this.subTrees.length; i < len; i++) {
            const subTree = this.subTrees[i];
            if (!subTree.box)
                continue;
            if (!ray.intersectsBox(subTree.box))
                continue; // 判断射线与盒子是否相交
            if (subTree?.triangleIndexs?.length > 0) {
                for (let j = 0, len = subTree.triangleIndexs.length; j < len; j++) {
                    triangleIndexs.add(subTree.triangleIndexs[j]);
                    // const indexStr = subTree.triangleIndexs[j];
                    // const index = base62.decode(indexStr);
                    // const triangle = list[index];
                    // triangles.push(triangle);
                }
            }
            else {
                subTree.getRayTriangleIndexs(ray, triangleIndexs, list);
            }
        }
    }
    /**
     * 球体与三角面相交检查
     * @param { Sphere } sphere 球体
     * @param { Triangle } triangle 三角形
     * @returns { Object | false } 返回相交详情，没有相交返回false
     */
    triangleSphereIntersect(sphere, triangle) {
        triangle.getPlane(_plane);
        if (!sphere.intersectsPlane(_plane))
            return false; // 检测球体是否与平面相交
        const depth = Math.abs(_plane.distanceToSphere(sphere)); // 返回球面 sphere 的边缘到平面的最短距离
        const r2 = sphere.radius * sphere.radius - depth * depth; // 距离平方
        const plainPoint = _plane.projectPoint(sphere.center, _v1); // 将球体中点投射到该平面上，得到投影点。
        // containsPoint: 如果球体中点投影到三角形的平面内，则返回true。
        if (triangle.containsPoint(sphere.center)) {
            return { normal: _plane.normal.clone(), point: plainPoint.clone(), depth: Math.abs(_plane.distanceToSphere(sphere)) };
        }
        const lines = [
            [triangle.a, triangle.b],
            [triangle.b, triangle.c],
            [triangle.c, triangle.a],
        ];
        for (let i = 0, len = lines.length; i < len; i++) {
            _line1.set(lines[i][0], lines[i][1]);
            _line1.closestPointToPoint(plainPoint, true, _v2); // 返回线段上到plainPoint最近的点。
            const d = _v2.distanceToSquared(sphere.center); // 计算该点到球体中心的平方距离。
            if (d < r2) {
                return { normal: sphere.center.clone().sub(_v2).normalize(), point: _v2.clone(), depth: sphere.radius - Math.sqrt(d) };
            }
        }
        return false;
    }
    /**
     * 胶囊体与三角面相交检查
     * @param { Capsule } capsule
     * @param { Triangle } triangle
     */
    triangleCapsuleIntersect(capsule, triangle) {
        triangle.getPlane(_plane);
        const d1 = _plane.distanceToPoint(capsule.start) - capsule.radius;
        const d2 = _plane.distanceToPoint(capsule.end) - capsule.radius;
        if ((d1 > 0 && d2 > 0) || (d1 < -capsule.radius && d2 < -capsule.radius))
            return false;
        const delta = Math.abs(d1 / (Math.abs(d1) + Math.abs(d2)));
        const intersectPoint = _v1.copy(capsule.start).lerp(capsule.end, delta); // 使用线性插值函数来预测一个实例在下一刻会移动到哪里
        if (triangle.containsPoint(intersectPoint)) {
            return { normal: _plane.normal.clone(), point: intersectPoint.clone(), depth: Math.abs(Math.min(d1, d2)) };
        }
        const r2 = capsule.radius * capsule.radius;
        const line1 = _line1.set(capsule.start, capsule.end);
        const lines = [
            [triangle.a, triangle.b],
            [triangle.b, triangle.c],
            [triangle.c, triangle.a],
        ];
        for (let i = 0; i < lines.length; i++) {
            const line2 = _line2.set(lines[i][0], lines[i][1]);
            const [point1, point2] = capsule.lineLineMinimumPoints(line1, line2);
            if (point1.distanceToSquared(point2) < r2) {
                return { normal: point1.clone().sub(point2).normalize(), point: point2.clone(), depth: capsule.radius - point1.distanceTo(point2) };
            }
        }
        return false;
    }
    /**
     * 球体相交检测
     * @param { Sphere } sphere 球体
     * @returns { Object | false } 返回相交面的法线，没有相交返回false
     */
    sphereIntersect(sphere) {
        _sphere.copy(sphere);
        const triangleIndexs = new Set();
        let result;
        let hit = false;
        this.getSphereTriangles(sphere, triangleIndexs, this.list);
        for (const item of triangleIndexs) {
            const index = base62.decode(item);
            const _triangle = this.list[index];
            if ((result = this.triangleSphereIntersect(_sphere, _triangle))) {
                hit = true;
                _sphere.center.add(result.normal.multiplyScalar(result.depth));
            }
        }
        if (hit) {
            const collisionVector = _sphere.center.clone().sub(sphere.center);
            const depth = collisionVector.length();
            return { normal: collisionVector.normalize(), depth: depth };
        }
        return false;
    }
    /**
     * 胶囊体相交检测
     * @param { Capsule } capsule 胶囊体
     * @returns { Object | false } 返回相交面的法线，没有相交返回false
     */
    capsuleIntersect(capsule) {
        _capsule.copy(capsule);
        const triangleIndexs = new Set();
        let result;
        let hit = false;
        this.getCapsuleTriangles(_capsule, triangleIndexs, this.list);
        for (const item of triangleIndexs) {
            const index = base62.decode(item);
            const _triangle = this.list[index];
            if ((result = this.triangleCapsuleIntersect(_capsule, _triangle))) {
                hit = true;
                _capsule.translate(result.normal.multiplyScalar(result.depth));
            }
        }
        if (hit) {
            const collisionVector = _capsule.getCenter(new Vector3()).sub(capsule.getCenter(_v1));
            const depth = collisionVector.length();
            return { normal: collisionVector.normalize(), depth: depth };
        }
        return false;
    }
    /**
     * 射线相交检测
     * @param { Ray } ray 射线
     * @returns { Object | false } 返回射线相交的第一个点，没有相交返回undefined
     */
    rayIntersect(ray) {
        if (ray.direction.length() === 0)
            return false;
        // const triangles: Triangle[] = [];
        const triangleIndexs = new Set();
        const maxDistance = 1e100;
        let triangle = new Triangle();
        let position = new Vector3();
        const normal = new Vector3();
        let distance = maxDistance; // 最大值
        this.getRayTriangleIndexs(ray, triangleIndexs, this.list); // 拿到射线穿过盒子中的所有三角面
        for (const item of triangleIndexs) {
            const index = base62.decode(item);
            const _triangle = this.list[index];
            const result = this.ray_triangle_intersection(_triangle.a, _triangle.b, _triangle.c, ray);
            if (result) {
                const _distance = result.sub(ray.origin).lengthSq(); // 计算相交点与射线起点距离
                if (distance > _distance) {
                    position = result;
                    distance = _distance;
                    triangle = _triangle;
                }
            }
        }
        triangle.getNormal(normal);
        return distance < maxDistance
            ? { distance: Math.sqrt(distance), triangle: triangle, normal: normal, position: position.clone().add(ray.origin) }
            : false;
    }
    ray_triangle_intersection(a, b, c, ray) {
        // const e1 = new Vector3();
        // const e2 = new Vector3();
        // const T = new Vector3();
        const EPSILON = 0.000001;
        _v1.subVectors(b, a);
        _v2.subVectors(c, a);
        const P = ray.direction.clone().cross(_v2); // 开始计算行列式-也用于计算u参数
        const det = _v1.dot(P); // 若行列式接近于零，光线位于三角形平面内
        if (det > -EPSILON && det < EPSILON)
            return false; // 不剔除
        const inv_det = 1 / det;
        _v3.subVectors(ray.origin, a);
        const u = _v3.dot(P) * inv_det;
        if (u < 0 || u > 1)
            return false;
        const Q = _v3.clone().cross(_v1);
        const v = ray.direction.dot(Q) * inv_det;
        if (v < 0 || u + v > 1)
            return false;
        const t = _v2.dot(Q) * inv_det;
        if (t > EPSILON)
            return ray.origin.clone().add(ray.direction.clone().multiplyScalar(t));
        return false;
    }
    /**
     * 线段相交检测
     * @param { Vector3 } start 起点
     * @param { Vector3 } end 终点
     * @returns { Object | false } 返回线段相交的第一个点，没有相交返回false
     */
    lineIntersect(start, end) {
        const line = new Line3(start, end);
        const triangleIndexs = new Set();
        const maxDistance = 1e100;
        let triangle = new Triangle();
        let position = new Vector3();
        const normal = new Vector3();
        let distance = maxDistance; // 最大值
        // const triangles: Triangle[] = [];
        this.getLineTriangles(line, triangleIndexs, this.list); // 拿到射线穿过盒子中的所有三角面
        for (const item of triangleIndexs) {
            const index = base62.decode(item);
            const _triangle = this.list[index];
            _triangle.getPlane(_plane);
            const result = _plane.intersectLine(line, _v1);
            if (!result)
                continue; // 检测线段是否与平面相交
            if (!_triangle.containsPoint(result))
                continue; // 检测交点是否在三角形内
            const _distance = result.sub(start).length(); // 计算相交点与线段起点距离
            if (distance > _distance) {
                position = result.clone().add(start);
                _triangle.getNormal(normal);
                distance = _distance;
                triangle = _triangle;
            }
        }
        return distance < maxDistance ? { distance: distance, triangle: triangle, normal: normal, position: position } : false;
    }
    /**
     * 以Group为基准，建立八叉树
     * @param { Object3D } group 根节点
     * @returns { Octree } 返回Octree本身
     */
    fromGraphNode(group) {
        // 将mesh打散为三角形
        group.updateWorldMatrix(true, true); // 更新世界坐标
        group.traverse((obj) => {
            if (obj instanceof Mesh) {
                let geometry;
                let isTemp = false;
                if (obj.geometry.index !== null) {
                    isTemp = true;
                    geometry = obj.geometry.toNonIndexed(); // 返回已索引的 BufferGeometry 的非索引版本
                }
                else {
                    geometry = obj.geometry;
                }
                const positionAttribute = geometry.getAttribute('position');
                totalNum += positionAttribute.count / 3;
                for (let i = 0, len = positionAttribute.count; i < len; i += 3) {
                    // 返回三角形的三个顶点世界坐标
                    const v1 = new Vector3().fromBufferAttribute(positionAttribute, i);
                    const v2 = new Vector3().fromBufferAttribute(positionAttribute, i + 1);
                    const v3 = new Vector3().fromBufferAttribute(positionAttribute, i + 2);
                    v1.applyMatrix4(obj.matrixWorld);
                    v2.applyMatrix4(obj.matrixWorld);
                    v3.applyMatrix4(obj.matrixWorld);
                    this.addTriangle(new Triangle(v1, v2, v3));
                    realTotalNum++;
                }
                if (isTemp) {
                    geometry.dispose();
                }
            }
        });
        console.log('总面数', totalNum, '八叉树包围的面数', realTotalNum);
        this.build();
        return this;
    }
    /**
     * 从对象中构建八叉树
     * @param { Octree } obj 原始对象
     * @param { Object3D } group 根节点
     * @returns { Octree } 返回Octree本身
     */
    fromObject(obj, group) {
        this.list = [];
        group.updateWorldMatrix(true, true); // 更新世界坐标
        group.traverse((obj) => {
            if (obj instanceof Mesh) {
                let geometry;
                let isTemp = false;
                if (obj.geometry.index !== null) {
                    isTemp = true;
                    geometry = obj.geometry.toNonIndexed(); // 返回已索引的 BufferGeometry 的非索引版本
                }
                else {
                    geometry = obj.geometry;
                }
                const positionAttribute = geometry.getAttribute('position');
                for (let i = 0, len = positionAttribute.count; i < len; i += 3) {
                    // 返回三角形的三个顶点世界坐标
                    const v1 = new Vector3().fromBufferAttribute(positionAttribute, i);
                    const v2 = new Vector3().fromBufferAttribute(positionAttribute, i + 1);
                    const v3 = new Vector3().fromBufferAttribute(positionAttribute, i + 2);
                    v1.applyMatrix4(obj.matrixWorld);
                    v2.applyMatrix4(obj.matrixWorld);
                    v3.applyMatrix4(obj.matrixWorld);
                    this.list?.push(new Triangle(v1, v2, v3));
                }
                if (isTemp) {
                    geometry.dispose();
                }
            }
        });
        this.list.sort(
        // 保证三角面排列一致
        (a, b) => a.a.x +
            a.a.y +
            a.a.z +
            a.b.x +
            a.b.y +
            a.b.z +
            a.c.x +
            a.c.y +
            a.c.z -
            (b.a.x + b.a.y + b.a.z + b.b.x + b.b.y + b.b.z + b.c.x + b.c.y + b.c.z));
        this.list.map((item, index) => this.addTriangleIndex(base62.encode(index)));
        function DP(parent, _obj) {
            parent.box = new Box3(new Vector3(_obj.box?.min.x, _obj.box?.min.y, _obj.box?.min.z), new Vector3(_obj.box?.max.x, _obj.box?.max.y, _obj.box?.max.z));
            parent.triangleIndexs = _obj.triangleIndexs;
            parent.subTrees = _obj.subTrees?.map((tree) => {
                const subTree = new Octree();
                DP(subTree, tree);
                return subTree;
            });
        }
        DP(this, obj);
        return this;
    }
    /**
     * 从对象中异步构建八叉树
     * @param { Octree } obj 原始对象
     * @param { Number } frameName 每个子任务可横跨的帧数
     * @returns { Promise<Boolean> } 返回promise对象
     */
    fromObjectAsync(obj, frameName = 2) {
        this.box = new Box3(new Vector3(obj.box?.min.x, obj.box?.min.y, obj.box?.min.z), new Vector3(obj.box?.max.x, obj.box?.max.y, obj.box?.max.z));
        this.triangles = obj.triangles?.map((triangle) => {
            return new Triangle(new Vector3(triangle.a.x, triangle.a.y, triangle.a.z), new Vector3(triangle.b.x, triangle.b.y, triangle.b.z), new Vector3(triangle.c.x, triangle.c.y, triangle.c.z));
        });
        this.subTrees = obj.subTrees?.map((tree) => {
            const subTree = new Octree(tree.box, tree.triangles, tree.subTrees);
            return subTree;
        });
        const treeList = [...this.subTrees];
        let now = Date.now();
        function processSubset(cb) {
            if (treeList.length !== 0) {
                const node = treeList.shift();
                node.subTrees = node.subTrees?.map((tree) => {
                    const subTree = new Octree(tree.box, tree.triangles, tree.subTrees);
                    return subTree;
                });
                treeList.push(...node.subTrees);
                const _now = Date.now();
                if (_now - now >= 16.6 * frameName) {
                    now = _now;
                    requestAnimationFrame(() => {
                        processSubset(cb);
                    });
                }
                else {
                    processSubset(cb);
                }
            }
            else {
                const status = true;
                cb(status);
            }
        }
        return new Promise((resolve, reject) => {
            processSubset(resolve);
        });
    }
}
export default Octree;
